import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { useRouter } from 'next/router'
import { siteConfig } from '@/constants/site'
import { getDictionary } from '@/i18n'

const OG_LOCALES: Record<string, string> = {
    de: 'de_DE',
    fr: 'fr_FR',
    en: 'en_GB',
    ar: 'ar_TN'
}

export const Seo: FC<SeoProps> = ({
    title,
    description,
    ogImage,
    noIndex = false
}): ReactNode => {
    const { locale } = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const pageDescription = description ?? getDictionary(locale).meta.homeDescription ?? siteConfig.description
    const image = ogImage ?? siteConfig.ogImage

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={pageDescription} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={pageDescription} />
            <meta property='og:type' content='website' />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content={OG_LOCALES[locale ?? 'de'] ?? 'de_DE'} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={pageDescription} />

            {image && <meta property='og:image' content={image} />}
            {image && <meta name='twitter:image' content={image} />}
            {noIndex && <meta name='robots' content='noindex, nofollow' />}
        </Head>
    )
}
